import React, { useEffect, useState } from "react";
import { BottomSheet } from "../components/BottomSheet.jsx";
import {
  DEFAULT_SHORTCUTS,
  FIXED_SHORTCUTS,
  SHORTCUT_CATEGORIES,
  SHORTCUTS_CHANGED_EVENT,
  formatCombo,
  getCombo
} from "./registry.js";

/** Key chips for a combo string, e.g. "Ctrl+B" → [Ctrl] [B]; sequences show "then". */
export function Kbd({ combo }) {
  return (
    <span className="kbd-combo">
      {formatCombo(combo).map((key, i) => (key === "then"
        ? <span key={i} className="kbd-then">then</span>
        : <kbd key={i} className="kbd-chip">{key}</kbd>))}
    </span>
  );
}

/** "?" overlay listing every shortcut by category (reflects user customisations). */
export function ShortcutHelp({ isOpen, onClose }) {
  const [, setVersion] = useState(0);
  useEffect(() => {
    const onChange = () => setVersion((v) => v + 1);
    window.addEventListener(SHORTCUTS_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(SHORTCUTS_CHANGED_EVENT, onChange);
  }, []);

  const rows = [
    ...DEFAULT_SHORTCUTS.map((s) => ({ label: s.label, category: s.category, combo: getCombo(s.id) })),
    ...FIXED_SHORTCUTS
  ];

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title="⌨️ Keyboard shortcuts">
      <div className="shortcut-help">
        {SHORTCUT_CATEGORIES.map((category) => {
          const items = rows.filter((r) => r.category === category && r.combo);
          if (!items.length) return null;
          return (
            <section key={category} className="shortcut-help-group">
              <h4 className="shortcut-help-title">{category}</h4>
              {items.map((item) => (
                <div key={item.label} className="shortcut-help-row">
                  <span>{item.label}</span>
                  {item.combo.includes("↑") ? <kbd className="kbd-chip">{item.combo}</kbd> : <Kbd combo={item.combo} />}
                </div>
              ))}
            </section>
          );
        })}
        <div className="shortcut-help-note">Change these in Settings → Keyboard shortcuts.</div>
      </div>
    </BottomSheet>
  );
}

export default ShortcutHelp;
